"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _construct = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/reflect/construct"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/toConsumableArray"));

var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/includes"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

var _slice = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/slice"));

var _parseInt2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/parse-int"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));

var _Button = _interopRequireDefault(require("../Button/Button"));

var _bind2 = _interopRequireDefault(require("classnames/bind"));

var _CustomPropTypes = _interopRequireDefault(require("../utils/CustomPropTypes/CustomPropTypes"));

var _gridManager = _interopRequireDefault(require("../utils/gridManager/gridManager"));

var _keycode = _interopRequireDefault(require("keycode"));

var _moment = _interopRequireDefault(require("moment"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _withStyles = _interopRequireDefault(require("../utils/withStyles"));

var _dateUtils = require("../utils/dateUtils");

var _react = _interopRequireWildcard(require("react"));

var _calendar = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("fundamental-styles/dist/calendar.css") : void 0);

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = (0, _construct.default)(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct.default) return false; if (_construct.default.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct.default)(Date, [], function () {})); return true; } catch (e) { return false; } }

var classnames = (0, _bind.default)(_bind2.default).call(_bind2.default, _calendar.default);
/** A **Calendar** is commonly used as the contents of a **Popover** when composing a **DatePicker**.
It is rarely used on its own as a standalone component. Internally it uses and accepts [Moment.js](https://momentjs.com/) date objects*/

var Calendar = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(Calendar, _Component);

  var _super = _createSuper(Calendar);

  function Calendar(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Calendar);
    _this = _super.call(this, props);

    _this.componentDidMount = function () {
      _this.gridManager = new _gridManager.default(_this.getGridOptions());
    };

    _this.componentDidUpdate = function (prevProps, prevState) {
      // if switching picker view or switching to a new month or year, reconstruct grid
      var newView = _this.state.showMonths !== prevState.showMonths || _this.state.showYears !== prevState.showYears;

      if (newView || _this.state.currentDateDisplayed.month() !== prevState.currentDateDisplayed.month() || _this.state.currentDateDisplayed.year() !== prevState.currentDateDisplayed.year()) {
        _this.gridManager.attachTo(_this.getGridOptions(newView));
      }
    };

    _this.getGridOptions = function (newView) {
      var cssNamespace = _this.props.cssNamespace;
      var _this$state = _this.state,
          gridBoundaryContext = _this$state.gridBoundaryContext,
          refocusGrid = _this$state.refocusGrid;
      var tableElement = _this.tableRef.current;
      var focusedDateElement = tableElement.querySelector('[data-is-focused=true]');
      var selectedDateElement = tableElement.querySelector(".".concat(classnames('is-selected')));
      var todayDateElement = tableElement.querySelector(".".concat(classnames("".concat(cssNamespace, "-calendar__item--current"))));
      var disabledDateElements = tableElement.querySelectorAll(".".concat(classnames("".concat(cssNamespace, "-calendar__item--other-month"))));
      var focusOnInit = newView || gridBoundaryContext || refocusGrid;
      var firstFocusedElement;

      if (focusedDateElement) {
        firstFocusedElement = focusedDateElement;
      } else if (selectedDateElement) {
        firstFocusedElement = selectedDateElement;
      } else {
        firstFocusedElement = todayDateElement;
      }

      var firstFocusedCoordinates = {
        row: 0,
        col: 0
      };

      if (gridBoundaryContext) {
        var currentCell = gridBoundaryContext.currentCell,
            directionX = gridBoundaryContext.directionX,
            directionY = gridBoundaryContext.directionY;
        var firstFocusedRow = currentCell && currentCell.row;
        var firstFocusedCol = currentCell && currentCell.col; // start from the bottom/top of the grid and keep searching for an available date in the direction used to pass the grid boundary

        if (directionX === -1) {
          firstFocusedRow = 5; // max 5 different weeks in view

          firstFocusedCol = 7;
        } else if (directionX === 1) {
          firstFocusedRow = 0;
          firstFocusedCol = 0;
        } else if (directionY === -1) {
          firstFocusedRow = 5;
        } else if (directionY === 1) {
          firstFocusedRow = 0;
        }

        firstFocusedCoordinates = {
          row: firstFocusedRow,
          col: firstFocusedCol
        };
      }

      _this.setState({
        gridBoundaryContext: null,
        refocusGrid: false
      });

      return {
        gridNode: _this.tableRef.current,
        firstFocusedElement: gridBoundaryContext ? null : firstFocusedElement,
        firstFocusedCoordinates: firstFocusedCoordinates,
        firstCellSearchDirection: gridBoundaryContext ? gridBoundaryContext : {
          directionX: 1,
          directionY: 0
        },
        enableHeaderCells: false,
        focusOnInit: focusOnInit,
        wrapRows: true,
        wrapCols: false,
        disabledCells: disabledDateElements,
        onPassBoundary: _this.onPassGridBoundary
      };
    };

    _this.showMonths = function () {
      _this.setState({
        showMonths: !_this.state.showMonths,
        showYears: false
      });
    };

    _this.isSelected = function (day) {
      var _this$state2 = _this.state,
          arrSelectedDates = _this$state2.arrSelectedDates,
          selectedDate = _this$state2.selectedDate;
      return (day.isSame(selectedDate, 'day') || _this.props.enableRangeSelection && ((typeof arrSelectedDates[0] !== 'undefined' ? arrSelectedDates[0].isSame(day, 'day') : false) || (typeof arrSelectedDates[1] !== 'undefined' ? arrSelectedDates[1].isSame(day, 'day') : false))) && (0, _dateUtils.isEnabledDate)(day, _this.props);
    };

    _this.isInSelectedRange = function (day) {
      return _this.props.enableRangeSelection && (0, _dateUtils.isDateBetween)(day, _this.state.arrSelectedDates, _this.props.enableRangeSelection);
    };

    _this.isSelectedRangeFirst = function (day) {
      return _this.props.enableRangeSelection && typeof _this.state.arrSelectedDates[0] !== 'undefined' && _this.state.arrSelectedDates[0].isSame(day);
    };

    _this.isSelectedRangeLast = function (day) {
      return _this.props.enableRangeSelection && typeof _this.state.arrSelectedDates[1] !== 'undefined' && _this.state.arrSelectedDates[1].isSame(day);
    };

    _this.showYears = function () {
      _this.setState({
        showMonths: false,
        showYears: !_this.state.showYears
      });
    };

    _this.changeMonth = function (month) {
      var newDate = (0, _moment.default)(_this.state.currentDateDisplayed).locale(_this.props.locale).month(month);

      _this.setState({
        currentDateDisplayed: newDate,
        screenReaderText: _this.props.localizedText.dayInstructions,
        showMonths: false
      });
    };

    _this.changeYear = function (year) {
      var newDate = (0, _moment.default)(_this.state.currentDateDisplayed).year(year);

      _this.setState({
        currentDateDisplayed: newDate,
        screenReaderText: _this.props.localizedText.dayInstructions,
        showYears: false
      });
    };

    _this.onPassGridBoundary = function (_ref) {
      var currentCell = _ref.currentCell,
          directionX = _ref.directionX,
          directionY = _ref.directionY;

      if (!_this.state.showMonths && !_this.state.showYears) {
        currentCell.element.setAttribute('tabindex', -1);

        _this.setState({
          gridBoundaryContext: {
            currentCell: currentCell,
            directionX: directionX,
            directionY: directionY
          }
        });

        if (directionX === -1 || directionY === -1) {
          _this.handlePrevious();
        } else if (directionX === 1 || directionY === 1) {
          _this.handleNext();
        }
      }
    };

    _this.onKeyDownCalendar = function (event) {
      var cssNamespace = _this.props.cssNamespace;
      var newDate;

      var focusedDateElement = _this.tableRef.current && _this.tableRef.current.querySelector(".".concat(cssNamespace, "-calendar__text:focus"));

      var focusedDate = (0, _parseInt2.default)(focusedDateElement && focusedDateElement.textContent, 10);

      switch ((0, _keycode.default)(event)) {
        case 'page up':
          event.preventDefault();
          newDate = (0, _moment.default)(_this.state.currentDateDisplayed).subtract(1, event.shiftKey ? 'year' : 'month');
          newDate.date(newDate.daysInMonth() < focusedDate ? newDate.daysInMonth() : focusedDate);

          _this.setState({
            currentDateDisplayed: newDate,
            refocusGrid: true
          });

          break;

        case 'page down':
          event.preventDefault();
          newDate = (0, _moment.default)(_this.state.currentDateDisplayed).add(1, event.shiftKey ? 'year' : 'month');
          newDate.date(newDate.daysInMonth() < focusedDate ? newDate.daysInMonth() : focusedDate);

          _this.setState({
            currentDateDisplayed: newDate,
            refocusGrid: true
          });

          break;

        default:
      }
    };

    _this.onKeyDownDay = function (event, onKeyFunction) {
      switch ((0, _keycode.default)(event)) {
        case 'enter':
        case 'space':
          event.preventDefault();
          event.stopPropagation();
          onKeyFunction();
          break;

        default:
      }
    };

    _this.generateMonths = function (monthProps) {
      var cssNamespace = _this.props.cssNamespace;

      var months = _moment.default.localeData(_this.props.locale).months();

      var gridArray = [];
      var i = 0;

      while (i < months.length) {
        gridArray.push((0, _slice.default)(months).call(months, i, i += 4));
      }

      var listOfMonths = (0, _map.default)(gridArray).call(gridArray, function (setOfMonths, index) {
        var monthCells = (0, _map.default)(setOfMonths).call(setOfMonths, function (month, subIndex) {
          var shortenedNameMonth = _moment.default.localeData(_this.props.locale).monthsShort()[subIndex + 4 * index];

          var isSelected = months[_this.state.currentDateDisplayed.month()] === month;
          var isFocused = _this.state.currentFocusMonth === month;
          var calendarItemClasses = classnames("".concat(cssNamespace, "-calendar__item"), (0, _defineProperty2.default)({
            'is-focus': isFocused,
            'is-selected': isSelected
          }, "".concat(cssNamespace, "-calendar__item--current"), months[_this.state.todayDate.month()] === month));
          return /*#__PURE__*/_react.default.createElement("td", {
            "aria-selected": isSelected,
            className: calendarItemClasses,
            key: month,
            name: month,
            onClick: function onClick() {
              return _this.changeMonth(month);
            },
            onFocus: _this.handleMonthFocus(month)
          }, /*#__PURE__*/_react.default.createElement("span", {
            className: classnames("".concat(cssNamespace, "-calendar__text")),
            onKeyDown: function onKeyDown(e) {
              var _context;

              return _this.onKeyDownDay(e, (0, _bind.default)(_context = _this.changeMonth).call(_context, (0, _assertThisInitialized2.default)(_this), month));
            },
            role: "button"
          }, shortenedNameMonth));
        });
        return /*#__PURE__*/_react.default.createElement("tr", {
          className: classnames("".concat(cssNamespace, "-calendar__row")),
          key: "month-row-".concat(index)
        }, monthCells);
      });
      return /*#__PURE__*/_react.default.createElement("div", {
        className: classnames("".concat(cssNamespace, "-calendar__months"))
      }, /*#__PURE__*/_react.default.createElement("table", (0, _extends2.default)({}, monthProps, {
        className: classnames("".concat(cssNamespace, "-calendar__table")),
        ref: _this.tableRef,
        role: "grid"
      }), /*#__PURE__*/_react.default.createElement("tbody", {
        className: classnames("".concat(cssNamespace, "-calendar__group"))
      }, listOfMonths)));
    };

    _this.generateYears = function (yearListProps) {
      var cssNamespace = _this.props.cssNamespace;

      var year = _this.state.currentDateDisplayed.year();

      var years = [];

      for (var row = 0; row < 3; row++) {
        years.push([]);

        for (var column = 0; column < 4; column++) {
          years[row][column] = year;
          year += 1;
        }
      }

      var listOfYears = (0, _map.default)(years).call(years, function (rowOfYears, index) {
        var yearCells = (0, _map.default)(rowOfYears).call(rowOfYears, function (element) {
          var isSelected = _this.state.currentDateDisplayed.year() === element;
          var isFocused = _this.state.currentFocusYear === element;
          var yearClasses = classnames("".concat(cssNamespace, "-calendar__item"), (0, _defineProperty2.default)({
            'is-focus': isFocused,
            'is-selected': isSelected
          }, "".concat(cssNamespace, "-calendar__item--current"), _this.state.todayDate.year() === element));
          return /*#__PURE__*/_react.default.createElement("td", {
            "aria-selected": isSelected,
            className: yearClasses,
            key: element,
            name: element,
            onClick: function onClick() {
              return _this.changeYear(element);
            },
            onFocus: _this.handleYearFocus(element)
          }, /*#__PURE__*/_react.default.createElement("span", {
            className: classnames("".concat(cssNamespace, "-calendar__text")),
            onKeyDown: function onKeyDown(e) {
              var _context2;

              return _this.onKeyDownDay(e, (0, _bind.default)(_context2 = _this.changeYear).call(_context2, (0, _assertThisInitialized2.default)(_this), element));
            },
            role: "button"
          }, element));
        });
        return /*#__PURE__*/_react.default.createElement("tr", {
          className: classnames("".concat(cssNamespace, "-calendar__row")),
          key: "year-row-".concat(index)
        }, yearCells);
      });
      return /*#__PURE__*/_react.default.createElement("div", {
        className: classnames("".concat(cssNamespace, "-calendar__years"))
      }, /*#__PURE__*/_react.default.createElement("table", (0, _extends2.default)({}, yearListProps, {
        className: classnames("".concat(cssNamespace, "-calendar__table")),
        ref: _this.tableRef,
        role: "grid"
      }), /*#__PURE__*/_react.default.createElement("tbody", {
        className: classnames("".concat(cssNamespace, "-calendar__group"))
      }, listOfYears)));
    };

    _this.handleNext = function () {
      var currentDateDisplayed = _this.state.currentDateDisplayed;

      var months = _moment.default.localeData(_this.props.locale).months();

      if (_this.state.showYears) {
        var newDate = (0, _moment.default)(currentDateDisplayed).add(12, 'year');

        _this.setState({
          currentDateDisplayed: newDate,
          screenReaderText: newDate.year()
        });
      } else {
        var _context3;

        var _newDate = (0, _moment.default)(currentDateDisplayed).add(1, 'month');

        _this.setState({
          currentDateDisplayed: _newDate,
          screenReaderText: (0, _concat.default)(_context3 = "".concat(months[_newDate.month()], " ")).call(_context3, _newDate.year())
        });
      }
    };

    _this.handlePrevious = function () {
      var currentDateDisplayed = _this.state.currentDateDisplayed;

      var months = _moment.default.localeData(_this.props.locale).months();

      if (_this.state.showYears) {
        var newDate = (0, _moment.default)(currentDateDisplayed).subtract(12, 'year');

        _this.setState({
          currentDateDisplayed: newDate,
          screenReaderText: newDate.year()
        });
      } else {
        var _context4;

        var _newDate2 = (0, _moment.default)(currentDateDisplayed).subtract(1, 'month');

        _this.setState({
          currentDateDisplayed: _newDate2,
          screenReaderText: (0, _concat.default)(_context4 = "".concat(months[_newDate2.month()], " ")).call(_context4, _newDate2.year())
        });
      }
    };

    _this.handleToday = function () {
      _this.dateClick(_this.state.todayDate, _this.props.enableRangeSelection, true);
    };

    _this.handleDayFocus = function (date) {
      return function () {
        _this.setState({
          currentFocusDay: date
        });
      };
    };

    _this.handleMonthFocus = function (month) {
      return function () {
        _this.setState({
          currentFocusMonth: month
        });
      };
    };

    _this.handleYearFocus = function (year) {
      return function () {
        _this.setState({
          currentFocusYear: year
        });
      };
    };

    _this.dateClick = function (day, isRangeEnabled) {
      var forceStayOpen = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var selectedDates = [];

      if (typeof isRangeEnabled !== 'undefined' && isRangeEnabled) {
        selectedDates = _this.state.arrSelectedDates;

        if (selectedDates.length === 2) {
          selectedDates = [day];
        } else if (typeof selectedDates[0] !== 'undefined' && day.isSameOrBefore(selectedDates[0])) {
          selectedDates = [day, selectedDates[0]];
        } else {
          selectedDates.push(day);
        }
      }

      _this.setState({
        currentDateDisplayed: day,
        screenReaderText: isRangeEnabled ? _this.props.localizedText.rangeInstructions : '',
        selectedDate: day,
        arrSelectedDates: selectedDates
      }, function () {
        if (isRangeEnabled) {
          this.props.onChange(selectedDates, forceStayOpen);
        } else {
          this.props.onChange(day, forceStayOpen);
        }
      });
    };

    _this.isDateBetween = function (date, blockedDates, isRangeEnabled) {
      if (typeof blockedDates === 'undefined' || typeof blockedDates[0] === 'undefined' || typeof blockedDates[1] === 'undefined') {
        return false;
      }

      if (typeof isRangeEnabled !== 'undefined' || isRangeEnabled) {
        if (blockedDates[0].isAfter(blockedDates[1])) {
          return blockedDates[1].isBefore(date) && blockedDates[0].isAfter(date);
        }
      }

      return blockedDates[0].isBefore(date, 'day') && blockedDates[1].isAfter(date, 'day');
    };

    _this.isWeekend = function (date) {
      var _context5;

      return (0, _includes.default)(_context5 = [0, 6]).call(_context5, date.day());
    };

    _this.isFocusedDay = function (date) {
      return _this.state.currentFocusDay.isSame(date);
    };

    _this.isFocusedMonth = function (date) {
      return _this.state.currentFocusDay.isSame(date);
    };

    _this.isFocusedYear = function (date) {
      return _this.state.currentFocusDay.isSame(date);
    };

    _this.specialDayType = function (date) {
      return _this.props.specialDays[date.format('YYYYMMDD')] ? _this.props.specialDays[date.format('YYYYMMDD')] : null;
    };

    _this.generateNavigation = function () {
      var cssNamespace = _this.props.cssNamespace;

      var months = _moment.default.localeData(_this.props.locale).months();

      var previousButtonLabel = _this.state.showYears ? _this.props.localizedText.show12PreviousYears : _this.props.localizedText.previousMonth;
      var nextButtonLabel = _this.state.showYears ? _this.props.localizedText.show12NextYears : _this.props.localizedText.nextMonth;
      var showToday = _this.props.showToday && !_this.state.showMonths && !_this.state.showYears;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: classnames("".concat(cssNamespace, "-calendar__header"))
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: classnames("".concat(cssNamespace, "-calendar__navigation"))
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: classnames("".concat(cssNamespace, "-calendar__action"))
      }, /*#__PURE__*/_react.default.createElement(_Button.default, {
        "aria-label": previousButtonLabel,
        compact: _this.props.compact,
        glyph: "slim-arrow-left",
        onClick: _this.handlePrevious,
        option: "transparent"
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: classnames("".concat(cssNamespace, "-calendar__action"))
      }, /*#__PURE__*/_react.default.createElement(_Button.default, {
        compact: _this.props.compact,
        onClick: _this.showMonths,
        option: "transparent"
      }, months[_this.state.currentDateDisplayed.month()])), /*#__PURE__*/_react.default.createElement("div", {
        className: classnames("".concat(cssNamespace, "-calendar__action"))
      }, /*#__PURE__*/_react.default.createElement(_Button.default, {
        compact: _this.props.compact,
        onClick: _this.showYears,
        option: "transparent"
      }, _this.state.currentDateDisplayed.year())), /*#__PURE__*/_react.default.createElement("div", {
        className: classnames("".concat(cssNamespace, "-calendar__action"))
      }, /*#__PURE__*/_react.default.createElement(_Button.default, {
        "aria-label": nextButtonLabel,
        compact: _this.props.compact,
        glyph: "slim-arrow-right",
        onClick: _this.handleNext,
        option: "transparent"
      })), showToday && /*#__PURE__*/_react.default.createElement("div", {
        className: classnames("".concat(cssNamespace, "-calendar__action"))
      }, /*#__PURE__*/_react.default.createElement(_Button.default, {
        compact: _this.props.compact,
        onClick: _this.handleToday,
        option: 'transparent'
      }, _this.props.localizedText.todayLabel))));
    };

    _this.shiftDays = function () {
      var startOnDay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var weekdays = arguments.length > 1 ? arguments[1] : undefined;

      var _weekdays = (0, _toConsumableArray2.default)(weekdays);

      var counter = startOnDay;

      while (counter > 0) {
        var day = _weekdays.shift();

        _weekdays.push(day);

        counter = counter - 1;
      }

      return _weekdays;
    };

    _this.generateWeekdays = function () {
      var cssNamespace = _this.props.cssNamespace;
      var weekDays = [];

      var daysName = _moment.default.localeData(_this.props.locale).weekdaysMin();

      var shiftedDaysName = _this.shiftDays(_this.normalizedWeekdayStart(), daysName);

      for (var index = 0; index < 7; index++) {
        weekDays.push( /*#__PURE__*/_react.default.createElement("th", {
          className: classnames("".concat(cssNamespace, "-calendar__item"), "".concat(cssNamespace, "-calendar__item--side-helper")),
          key: index
        }, /*#__PURE__*/_react.default.createElement("span", {
          className: classnames("".concat(cssNamespace, "-calendar__text"))
        }, shiftedDaysName[index])));
      }

      return /*#__PURE__*/_react.default.createElement("tr", {
        className: classnames("".concat(cssNamespace, "-calendar__row"))
      }, weekDays);
    };

    _this.normalizedWeekdayStart = function () {
      var weekdayStart = (0, _parseInt2.default)(_this.props.weekdayStart, 10);

      if (!isNaN(weekdayStart) && weekdayStart >= 0 && weekdayStart <= 6) {
        return weekdayStart;
      }

      return 0;
    };

    _this.generateDays = function (tableBodyProps) {
      var _context6;

      var cssNamespace = _this.props.cssNamespace;
      var _this$state3 = _this.state,
          currentDateDisplayed = _this$state3.currentDateDisplayed,
          todayDate = _this$state3.todayDate;
      var blockedDates = _this.props.blockedDates && (0, _map.default)(_context6 = _this.props.blockedDates).call(_context6, function (date) {
        return (0, _moment.default)(date);
      });
      var enableRangeSelection = _this.props.enableRangeSelection;
      var firstDayMonth = (0, _moment.default)(currentDateDisplayed).startOf('month');
      var firstDayWeekMonth = (0, _moment.default)(firstDayMonth).day(0).day(_this.normalizedWeekdayStart());
      var isAfterFirstDayMonth = (0, _moment.default)(firstDayWeekMonth).isAfter(firstDayMonth);
      var rows = [];
      var days = [];
      var day = isAfterFirstDayMonth ? firstDayWeekMonth.subtract(7, 'days') : firstDayWeekMonth;
      var dateFormatted = '';

      for (var week = 0; week < 6; week++) {
        var _loop = function _loop(iterations) {
          var _context7, _classnames3;

          dateFormatted = day.date();
          var copyDate = (0, _moment.default)(day);
          var isDisabled = !(0, _dateUtils.isEnabledDate)(day, _this.props);
          var isBlocked = (0, _dateUtils.isDateBetween)(day, blockedDates);
          var ariaLabel = copyDate.format(_moment.default.localeData(_this.props.locale).longDateFormat('LL'));

          var specialDayType = _this.specialDayType(day);

          if (isDisabled || isBlocked) {
            ariaLabel += ' ' + _moment.default.localeData(_this.props.locale).invalidDate();
          }

          var dayClasses = classnames("".concat(cssNamespace, "-calendar__item"), (_classnames3 = {}, (0, _defineProperty2.default)(_classnames3, "".concat(cssNamespace, "-calendar__item--other-month"), !day.isSame(currentDateDisplayed, 'month')), (0, _defineProperty2.default)(_classnames3, "".concat(cssNamespace, "-calendar__item--current"), todayDate.isSame(copyDate)), (0, _defineProperty2.default)(_classnames3, "".concat(cssNamespace, "-calendar__item--weekend"), _this.isWeekend(day)), (0, _defineProperty2.default)(_classnames3, "".concat(cssNamespace, "-calendar__item--range"), _this.isInSelectedRange(day)), (0, _defineProperty2.default)(_classnames3, (0, _concat.default)(_context7 = "".concat(cssNamespace, "-calendar__special-day--")).call(_context7, specialDayType), !!specialDayType), (0, _defineProperty2.default)(_classnames3, 'is-active', _this.isSelected(day) || _this.isSelectedRangeFirst(day) || _this.isSelectedRangeLast(day)), (0, _defineProperty2.default)(_classnames3, 'is-disabled', isDisabled), (0, _defineProperty2.default)(_classnames3, 'is-blocked', isBlocked), (0, _defineProperty2.default)(_classnames3, 'is-focus', _this.isFocusedDay(day)), _classnames3));
          days.push( /*#__PURE__*/_react.default.createElement("td", {
            "aria-disabled": isDisabled,
            "aria-selected": _this.isSelected(day),
            className: dayClasses,
            "data-is-focused": day.isSame(currentDateDisplayed),
            key: copyDate,
            onClick: (0, _dateUtils.isEnabledDate)(day, _this.props) ? function () {
              return _this.dateClick(copyDate, enableRangeSelection);
            } : null,
            onFocus: _this.handleDayFocus(day),
            role: "gridcell"
          }, /*#__PURE__*/_react.default.createElement("span", {
            "aria-label": ariaLabel,
            className: classnames("".concat(cssNamespace, "-calendar__text")),
            onKeyDown: (0, _dateUtils.isEnabledDate)(day, _this.props) ? function (e) {
              var _context8;

              return _this.onKeyDownDay(e, (0, _bind.default)(_context8 = _this.dateClick).call(_context8, (0, _assertThisInitialized2.default)(_this), copyDate, enableRangeSelection));
            } : null,
            role: "button"
          }, dateFormatted.toString())));
          day = (0, _moment.default)(day).add(1, 'days');
        };

        for (var iterations = 0; iterations < 7; iterations++) {
          _loop(iterations);
        }

        rows.push( /*#__PURE__*/_react.default.createElement("tr", {
          className: classnames("".concat(cssNamespace, "-calendar__row")),
          key: day
        }, days));
        days = [];
      }

      return /*#__PURE__*/_react.default.createElement("tbody", (0, _extends2.default)({}, tableBodyProps, {
        className: classnames("".concat(cssNamespace, "-calendar__group"))
      }), rows);
    };

    _this._renderContent = function (monthListProps, yearListProps, tableProps, tableHeaderProps, tableBodyProps) {
      var cssNamespace = _this.props.cssNamespace;

      if (_this.state.showMonths) {
        return _this.generateMonths(monthListProps);
      }

      if (_this.state.showYears) {
        return _this.generateYears(yearListProps);
      }

      return /*#__PURE__*/_react.default.createElement("div", {
        className: classnames("".concat(cssNamespace, "-calendar__dates"))
      }, /*#__PURE__*/_react.default.createElement("table", (0, _extends2.default)({}, tableProps, {
        className: classnames("".concat(cssNamespace, "-calendar__table")),
        ref: _this.tableRef,
        role: "grid"
      }), /*#__PURE__*/_react.default.createElement("thead", (0, _extends2.default)({}, tableHeaderProps, {
        className: classnames("".concat(cssNamespace, "-calendar__group"))
      }), _this.generateWeekdays()), _this.generateDays(tableBodyProps)));
    };

    var _currentDateDisplayed = props.openToDate || (0, _moment.default)().startOf('day');

    var selectedDateOrDates = !props.enableRangeSelection ? (0, _moment.default)({
      year: 0
    }) : [];
    var customDateEmpty = !props.customDate || props.customDate && props.customDate.length === 0;

    if (!customDateEmpty) {
      selectedDateOrDates = props.customDate;
      _currentDateDisplayed = props.customDate;

      if (props.customDate.length) {
        _currentDateDisplayed = props.customDate[0];
      }
    }

    _this.state = {
      todayDate: (0, _moment.default)().startOf('day'),
      gridBoundaryContext: null,
      refocusGrid: props.focusOnInit,
      currentDateDisplayed: _currentDateDisplayed,
      arrSelectedDates: props.enableRangeSelection ? selectedDateOrDates : [],
      screenReaderText: '',
      selectedDate: !props.enableRangeSelection ? selectedDateOrDates : null,
      showMonths: false,
      showYears: false,
      currentFocusDay: _currentDateDisplayed.startOf('day'),
      currentFocusYear: _currentDateDisplayed.year(),
      currentFocusMonth: _currentDateDisplayed.month()
    };
    _this.tableRef = /*#__PURE__*/_react.default.createRef();
    return _this;
  }

  (0, _createClass2.default)(Calendar, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          compact = _this$props.compact,
          cssNamespace = _this$props.cssNamespace,
          enableRangeSelection = _this$props.enableRangeSelection,
          disableWeekends = _this$props.disableWeekends,
          disableBeforeDate = _this$props.disableBeforeDate,
          disableAfterDate = _this$props.disableAfterDate,
          disableWeekday = _this$props.disableWeekday,
          disablePastDates = _this$props.disablePastDates,
          disableFutureDates = _this$props.disableFutureDates,
          blockedDates = _this$props.blockedDates,
          disabledDates = _this$props.disabledDates,
          customDate = _this$props.customDate,
          className = _this$props.className,
          focusOnInit = _this$props.focusOnInit,
          localizedText = _this$props.localizedText,
          monthListProps = _this$props.monthListProps,
          openToDate = _this$props.openToDate,
          yearListProps = _this$props.yearListProps,
          tableProps = _this$props.tableProps,
          tableHeaderProps = _this$props.tableHeaderProps,
          tableBodyProps = _this$props.tableBodyProps,
          showToday = _this$props.showToday,
          specialDays = _this$props.specialDays,
          weekdayStart = _this$props.weekdayStart,
          props = (0, _objectWithoutProperties2.default)(_this$props, ["compact", "cssNamespace", "enableRangeSelection", "disableWeekends", "disableBeforeDate", "disableAfterDate", "disableWeekday", "disablePastDates", "disableFutureDates", "blockedDates", "disabledDates", "customDate", "className", "focusOnInit", "localizedText", "monthListProps", "openToDate", "yearListProps", "tableProps", "tableHeaderProps", "tableBodyProps", "showToday", "specialDays", "weekdayStart"]);
      var calendarClasses = classnames("".concat(cssNamespace, "-calendar"), (0, _defineProperty2.default)({}, "".concat(cssNamespace, "-calendar--compact"), compact), className);
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, props, {
        className: calendarClasses,
        onKeyDown: function onKeyDown(e) {
          return _this2.onKeyDownCalendar(e);
        }
      }), this.generateNavigation(), /*#__PURE__*/_react.default.createElement("div", {
        className: classnames("".concat(cssNamespace, "-calendar__content")),
        onBlur: function onBlur(e) {
          if (!e.currentTarget.contains(e.relatedTarget)) {
            _this2.setState({
              screenReaderText: ''
            });
          }
        },
        onFocus: function onFocus() {
          var instructions = localizedText.dayInstructions;

          if (_this2.state.showYears) {
            instructions = localizedText.yearInstructions;
          } else if (_this2.state.showMonths) {
            instructions = localizedText.monthInstructions;
          }

          _this2.setState({
            screenReaderText: instructions
          });
        }
      }, this._renderContent(monthListProps, yearListProps, tableProps, tableHeaderProps, tableBodyProps))), /*#__PURE__*/_react.default.createElement("div", {
        "aria-live": "polite",
        className: classnames("".concat(cssNamespace, "-calendar__content"), "".concat(cssNamespace, "-calendar__content--screen-reader-only"))
      }, this.state.screenReaderText));
    }
  }]);
  return Calendar;
}(_react.Component);

Calendar.displayName = 'Calendar';
process.env.NODE_ENV !== "production" ? Calendar.propTypes = {
  /** Blocks dates that are in between the blocked dates */
  blockedDates: _propTypes.default.arrayOf(_propTypes.default.instanceOf(_moment.default)),

  /** CSS class(es) to add to the element */
  className: _propTypes.default.string,

  /** Set to **true** to enable compact mode */
  compact: _propTypes.default.bool,
  customDate: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.array]),

  /** Disables dates of a calendar that come after the specified date */
  disableAfterDate: _propTypes.default.instanceOf(_moment.default),

  /** Disables dates of a calendar that come before the specified date */
  disableBeforeDate: _propTypes.default.instanceOf(_moment.default),

  /** Disables dates that are in between the disabled dates */
  disabledDates: _propTypes.default.arrayOf(_propTypes.default.instanceOf(_moment.default)),

  /** Set to **true** to disable dates after today\'s date */
  disableFutureDates: _propTypes.default.bool,

  /** Set to **true** to disable dates before today\'s date */
  disablePastDates: _propTypes.default.bool,

  /** Disables dates that match a weekday. For example, `disableWeekday={[\'Tuesday\', \'Thursday\', \'Friday\']}` */
  disableWeekday: _propTypes.default.arrayOf(_propTypes.default.string),

  /** Set to **true** to disables dates that match a weekend */
  disableWeekends: _propTypes.default.bool,

  /** Set to **true** to enable the Calendar's range selection feature */
  enableRangeSelection: _propTypes.default.bool,

  /** Set to **true** to focus the calendar grid upon being mounted */
  focusOnInit: _propTypes.default.bool,

  /** Moment.js locale keys */
  locale: _propTypes.default.string,

  /** Localized text to be updated based on location/language */
  localizedText: _CustomPropTypes.default.i18n({
    /** Localized string informing screen reader users the calendar can be navigated by arrow keys while in day view */
    dayInstructions: _propTypes.default.string,

    /** Localized string informing screen reader users the calendar can be navigated by arrow keys while in month view */
    monthInstructions: _propTypes.default.string,

    /** Localized string informing screen reader users the calendar can be navigated by arrow keys while in year view */
    yearInstructions: _propTypes.default.string,

    /** Localized string informing screen reader users to select a second date when in range selection */
    rangeInstructions: _propTypes.default.string,

    /** aria-label for next button */
    nextMonth: _propTypes.default.string,

    /** aria-label for previous button */
    previousMonth: _propTypes.default.string,

    /** aria-label for next button when years are displayed */
    show12NextYears: _propTypes.default.string,

    /** aria-label for previous button when years are displayed */
    show12PreviousYears: _propTypes.default.string,

    /** aria-label for Today button if included */
    todayLabel: _propTypes.default.string
  }),

  /** Additional props to be spread to the month\'s `<table>` element */
  monthListProps: _propTypes.default.object,

  /** Date to focus when the calendar is loaded and no date is selected */
  openToDate: _propTypes.default.instanceOf(_moment.default),

  /** Set to **true** if the Today button should be displayed */
  showToday: _propTypes.default.bool,

  /** Object with special dates and special date types in shape of `{'YYYYMMDD': type}`. Type must be a number between 1-20 */
  specialDays: _propTypes.default.object,

  /** Additional props to be spread to the `<tbody>` element */
  tableBodyProps: _propTypes.default.object,

  /** Additional props to be spread to the `<thead>` element */
  tableHeaderProps: _propTypes.default.object,

  /** Additional props to be spread to the `<table>` element */
  tableProps: _propTypes.default.object,

  /** Number to indicate which day the week should start. 0 = Sunday, 1 = Monday, 2 = Tuesday, 3 = Wednesday, 4 = Thursday, 5 = Friday, 6 = Saturday */
  weekdayStart: _CustomPropTypes.default.range(0, 6),

  /** Additional props to be spread to the year\'s `<table>` element */
  yearListProps: _propTypes.default.object,

  /**
   * Callback function when the date selection changes.
   *
   *  * If `enableRangeSelection` is **false** the function is called when any date is selected, with a Moment.js date object
   *  * If `enableRangeSelection` is **true** the function is called when any date is selected, with an array of Moment.js date objects. The max size of this array is 2 i.e. the start and end date.
   *
   * @param {(Moment | Moment[])} date single Moment.js date object if range selection is disabled, else an array containing 2 Moment.js date objects.
   * @param {Boolean} todayPressed - is true only if the change was caused by the today button.
   * @returns {void}
  */
  onChange: _propTypes.default.func
} : void 0;
Calendar.defaultProps = {
  compact: false,
  locale: 'en',
  localizedText: {
    dayInstructions: 'Use arrow keys to move between days.',
    monthInstructions: 'Use arrow keys to move between months.',
    yearInstructions: 'Use arrow keys to move between years.',
    rangeInstructions: 'First date selected. Please select a second date.',
    nextMonth: 'Next month',
    previousMonth: 'Previous month',
    show12NextYears: 'Show 12 next years',
    show12PreviousYears: 'Show 12 previous years',
    todayLabel: 'Today'
  },
  onChange: function onChange() {},
  specialDays: {},
  weekdayStart: 0
};

var _default = (0, _withStyles.default)(Calendar);

exports.default = _default;